import React, { useContext, useReducer, useState, useEffect } from 'react'
import ListingViewHOC from '../../../HOC/module/ListingViewHOC';
import moduleConfig from "./moduleConfig"
import useConfirm from '../../../HOC/custom/useConfirm';
import { useLocation, useNavigate, Link, useParams } from 'react-router-dom';
import { BreadcrumbContext } from '../../../contexts/BreadcrumbContext';
import { listingInitialState, listingReducer } from './reducers/listingReducer';
import queryString from "query-string";
import axios from "../../../config/axios";
import { Store as toast } from "react-notifications-component";
import { toastNotification } from "../../../config/toastNotification";
import DashboardLayout from '../../UI/layouts/DashboardLayout';
import { OverlayLoading } from '../../UI/loading/OverlayLoading';
import BlockErrorMessage from '../../UI/errorMessages/BlockErrorMessage';
import ModuleHeader from '../../UI/modules/views/partials/common/ModuleHeader';
import SearchArea from './partials/listing/SearchArea';
import FormErrorMessage from '../../UI/errorMessages/FormErrorMessage';
import { Alert, Col, Row, Table } from 'react-bootstrap';
import Item from './partials/listing/Item';
import ListingFooter from './partials/listing/ListingFooter';
import ModuleDisplayBoolean from '../../UI/modules/fieldsDisplay/ModuleDisplayBoolean';
import ModuleDisplayPhone from '../../UI/modules/fieldsDisplay/ModuleDisplayPhone';
import ModuleDisplayEmail from '../../UI/modules/fieldsDisplay/ModuleDisplayEmail';
let breadcrumbs = {
    listing: {
        label: moduleConfig.title,
        url: `/${moduleConfig.url}`
    }
};


const ContactUsOsmaListing = () => {
    const { setBreadcrumb } = useContext(BreadcrumbContext);
    const [listingState, listingDispatch] = useReducer(
        listingReducer,
        listingInitialState
    );
    const [isCheck, setIsCheck] = useState([]);
    const [isCheckAll, setIsCheckAll] = useState(false);
    const { confirm } = useConfirm();

    const { search } = useLocation();
    const [appliedFilters, setAppliedFilters] = useState(
        queryString.parse(search)
    );
    if (appliedFilters.limit) {
        moduleConfig.perPageItems = appliedFilters.limit;
    }

    let history = useNavigate();

    const setFilter = (name, value) => {

        let newAppliedFilters = JSON.parse(JSON.stringify(appliedFilters));

        if (value) {
            newAppliedFilters[name] = value;
        } else {
            delete newAppliedFilters[name];
        }

        if (name !== "page") {
            delete newAppliedFilters["page"];
        }

        if (name === "limit" || name === "page") {
            setIsCheck([]);
            setIsCheckAll(false);
        }

        let newURL = queryString.stringify(newAppliedFilters);
        history({ search: newURL });
        setAppliedFilters(newAppliedFilters);
    };

    const loadItems = async () => {
        listingDispatch({
            type: "FETCH_REQUEST",
        });

        try {
            const res = await axios.get(`${moduleConfig.url}${search}`); //
            listingDispatch({
                type: "FETCH_SUCCESS",
                payload: res.data,
            });
        } catch (error) {
            listingDispatch({
                type: "FETCH_FAILURE",
                payload: error,
            });
        }
    };

    const resetFilters = () => {
        //console.log(`resetFilters called`)
        let newAppliedFilters = JSON.parse(JSON.stringify(appliedFilters));

        moduleConfig.perPageItems = 10;
        delete newAppliedFilters["limit"];
        delete newAppliedFilters["status"];
        delete newAppliedFilters["clientId"];
        delete newAppliedFilters["activityId"];
        delete newAppliedFilters["q"];

        let newURL = queryString.stringify(newAppliedFilters);
        history({ search: newURL });
        //console.log(newAppliedFilters);
        setAppliedFilters(newAppliedFilters);
    };

    const performBulkAction = async (action) => {
        listingDispatch({
            type: "BULK_ACTION_REQUEST",
        });

        try {
            const res = await axios.post(`${moduleConfig.url}/bulk-action`, {
                ids: isCheck,
                action,
            });
            setIsCheck([]);
            setIsCheckAll(false);
            loadItems();
            toast.addNotification({
                ...toastNotification,
                title: "Success!",
                message: `Action "${action}" on selected items was performed successfully.`,
                type: "success",
            });
        } catch (error) {
            listingDispatch({
                type: "BULK_ACTION_FAILURE",
                payload: error,
            });

            setTimeout(() => {
                listingDispatch({
                    type: "REMOVE_ERROR",
                });
            }, 5000);
        }
    };

    useEffect(() => {
        loadItems();
    }, [search]);

    useEffect(() => {
        setBreadcrumb([breadcrumbs.listing]);
    }, []);
    let user = JSON.parse(localStorage.getItem('user'));
    const handleSelectAll = () => {
        setIsCheckAll(!isCheckAll);

        if (listingState.data.items && listingState.data.items.length) {
            setIsCheck(listingState.data.items.map((li) => li._id));
        }

        if (isCheckAll) {
            setIsCheck([]);
        }
    };

    const confirmAndDisabled = async (id) => {
        const isConfirmed = await confirm(
            `Do you really want to disable this ${moduleConfig.singleItemTitle}?`
        );

        if (isConfirmed) {
            await changeStatus(id);
        }
    };

    const confirmAndDelete = async (id) => {
        const isConfirmed = await confirm(
            `Do you really want to delete this ${moduleConfig.singleItemTitle}?`
        );

        if (isConfirmed) {
            await deleteItem(id);
        }
    };
    const confirmAndEnabled = async (id) => {
        const isConfirmed = await confirm(
            `Do you really want to enable this ${moduleConfig.singleItemTitle}?`
        );

        if (isConfirmed) {
            await changeStatus(id, true);
        }
    };
    const deleteItem = async (id) => {
        listingDispatch({
            type: "DELETE_REQUEST",
        });
        try {
            const res = await axios.delete(`${moduleConfig.url}/${id}`);
            loadItems();
            // listingDispatch({
            //     type: "DELETE_SUCCESS"
            // });
            toast.addNotification({
                ...toastNotification,
                title: "Success!",
                message: `${moduleConfig.singleItemTitle} deleted successfully.`,
                type: "success",
            });
        } catch (error) {
            listingDispatch({
                type: "DELETE_FAILURE",
                payload: error,
            });

            setTimeout(() => {
                listingDispatch({
                    type: "REMOVE_ERROR",
                });
            }, 5000);
        }
    };
    const changeStatus = async (id, undo = false) => {

        listingDispatch({
            type: "BLOCK_REQUEST",
        });

        try {
            const res = await axios.post(`${moduleConfig.url}/change-status`, {
                id,
                status: undo === true ? "1" : "0",
            });
            loadItems();
            // listingDispatch({
            //     type: "DELETE_SUCCESS"
            // });
            toast.addNotification({
                ...toastNotification,
                title: "Success!",
                message: `${moduleConfig.singleItemTitle} ${undo ? "enabled" : "disabled"
                    } successfully.`,
                type: "success",
            });
        } catch (error) {
            listingDispatch({
                type: "BLOCK_FAILURE",
                payload: error,
            });

            setTimeout(() => {
                listingDispatch({
                    type: "REMOVE_ERROR",
                });
            }, 5000);
        }
    };

    const handleCheckBoxClick = (e) => {
        const { id, checked } = e.target;
        setIsCheck([...isCheck, id]);
        if (!checked) {
            setIsCheck(isCheck.filter((item) => item !== id));
        }
        setIsCheckAll(false);
    };

    return (
        <DashboardLayout>
            {listingState.isLoading && <OverlayLoading />}

            {listingState.status !== "fetching" && (
                <>
                    {listingState.error && listingState.status === "fetchFailed" ? (
                        <BlockErrorMessage error={listingState.error} />
                    ) : (
                        <>
                            <ModuleHeader
                                moduleTitle={moduleConfig.title}
                                moduleUrl={moduleConfig.url}
                            >
                                {moduleConfig.buttons &&
                                    moduleConfig.buttons.create === true && (
                                        <Link
                                            to={`/${moduleConfig.url}/create`}
                                            className="btn btn-primary"
                                        >
                                            Create {moduleConfig.singleItemTitle}
                                        </Link>
                                    )}
                            </ModuleHeader>

                            <div className="listingPage position-relative">

                                {listingState.data &&
                                    listingState.data.pagination &&
                                    listingState.data.pagination.totalItems > 0 ? (
                                    <>
                                        {/* Search Area */}
                                        <SearchArea
                                            moduleConfig={moduleConfig}
                                            setFilter={setFilter}
                                            appliedFilters={appliedFilters}
                                            resetFilters={resetFilters}
                                        />

                                        {/* Listing */}
                                        <section className="content listing ">
                                            {listingState.error && (
                                                <FormErrorMessage error={listingState.error} />
                                            )}

                                            {!listingState.data.items ||
                                                listingState.data.items.length <= 0 ? (
                                                <Alert variant="warning">
                                                    No records found with selected filters.{" "}
                                                    <Alert.Link href="#" onClick={() => resetFilters()}>
                                                        <i className="fas fa-times" /> Reset Filters
                                                    </Alert.Link>
                                                    .
                                                </Alert>
                                            ) : (
                                                <>
                                                    {listingState.data.items &&
                                                        listingState.data.items.length && (
                                                            <>
                                                                <Row className="m-0 p-0 mt-2">
                                                                    <Col className="m-0 mb-1">
                                                                        <input
                                                                            className="selectAll"
                                                                            type="checkbox"
                                                                            name="selectAll"
                                                                            id="selectAll"
                                                                            onChange={handleSelectAll}
                                                                            checked={isCheckAll}
                                                                        />
                                                                        <label
                                                                            for="selectAll"
                                                                            className="m-0 p-0 ml-2"
                                                                        >
                                                                            Select All
                                                                        </label>
                                                                    </Col>
                                                                </Row>
                                                                <Table striped bordered className="mb-0">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>#</th>
                                                                            <th>No</th>
                                                                            <th>First Name</th>
                                                                            <th>Last Name</th>
                                                                            <th>Email</th>
                                                                            <th>Mobile</th>
                                                                            <th >Company</th>
                                                                            <th >Designation</th>

                                                                            <th></th>
                                                                        </tr>
                                                                    </thead>
                                                                    {listingState.data.items.map(
                                                                        (item, itemIndex) => {
                                                                            return (
                                                                                <tbody key={itemIndex}>

                                                                                    <tr>
                                                                                        <td>
                                                                                            <div className="checkboxCol">
                                                                                                <input
                                                                                                    type="checkbox"
                                                                                                    id={item._id}
                                                                                                    name={item._id}
                                                                                                    onChange={handleCheckBoxClick}
                                                                                                    checked={isCheck.includes(item._id)}
                                                                                                />
                                                                                            </div>
                                                                                        </td>
                                                                                        <td>{itemIndex + 1}</td>


                                                                                        <td>
                                                                                            {item.firstName}
                                                                                        </td>
                                                                                        <td>
                                                                                            {item.lastName}
                                                                                        </td>
                                                                                        <td>
                                                                                            <ModuleDisplayEmail
                                                                                                value={item.email}
                                                                                            />
                                                                                        </td>
                                                                                        <td>
                                                                                            <ModuleDisplayPhone
                                                                                                value={item.mobile}
                                                                                            />
                                                                                        </td>
                                                                                        <td>
                                                                                            {item.company}
                                                                                        </td>
                                                                                        <td >{item.designation}</td>



                                                                                        {/* <td>{item.sortOrder}</td> */}

                                                                                        <td
                                                                                            className={`text-center record-actions  MoreItem`}
                                                                                        >
                                                                                            <Link title="View Item"
                                                                                                to={`/osma-contact-us/${item._id}`}
                                                                                                className="btn btn-outline-secondary btn-sm"
                                                                                            >
                                                                                                <i className="fas fa-eye"></i>
                                                                                            </Link>


                                                                                            {(item.status === "1" || item.status === 1) && (
                                                                                                <span
                                                                                                    title="Disable Item"
                                                                                                    onClick={() => confirmAndDisabled(item._id)}
                                                                                                    className="btn btn-outline-secondary btn-sm ms-1 mt-xl-0 mt-md-0 mt-lg-0 mt-1"
                                                                                                >
                                                                                                    <i className="fas fa-ban"></i>
                                                                                                </span>
                                                                                            )}

                                                                                            {(item.status === "0" || item.status === 0) && (
                                                                                                <span
                                                                                                    title="Enable Item"
                                                                                                    onClick={() => confirmAndEnabled(item._id)}
                                                                                                    className="btn btn-outline-secondary btn-sm ms-1 mt-xl-0 mt-md-0 mt-lg-0 mt-1"
                                                                                                >
                                                                                                    <i className="fas fa-undo"></i>
                                                                                                </span>
                                                                                            )}

                                                                                            <span title="Delete Item"
                                                                                                onClick={() =>
                                                                                                    confirmAndDelete(item._id)
                                                                                                }
                                                                                                className="btn btn-outline-secondary btn-sm ms-1 mt-xl-0 mt-md-0 mt-lg-0 mt-1"
                                                                                            >
                                                                                                <i className="fas fa-trash"></i>
                                                                                            </span>
                                                                                        </td>
                                                                                    </tr>

                                                                                </tbody>
                                                                            );
                                                                        }
                                                                    )}

                                                                </Table>

                                                            </>
                                                        )}
                                                </>
                                            )}
                                        </section>

                                        <ListingFooter
                                            listingState={listingState}
                                            moduleConfig={moduleConfig}
                                            isCheck={isCheck}
                                            performBulkAction={performBulkAction}
                                            setFilter={setFilter}
                                        />
                                    </>
                                ) : (
                                    <Alert variant="warning">No records found.</Alert>
                                )}
                            </div>
                        </>
                    )}
                </>
            )}
        </DashboardLayout>
    );
};
export default ContactUsOsmaListing;
